
import { CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Client } from "../../types";
import { FieldIndicator } from "./FieldIndicator";

interface CompanyOverviewHeaderProps {
  client: Client;
  fieldsWithNewData: Set<keyof Client>;
}

export const CompanyOverviewHeader: React.FC<CompanyOverviewHeaderProps> = ({ client, fieldsWithNewData }) => {
  return (
    <CardHeader>
      <CardTitle className="text-2xl flex items-center">
        Company Overview 
        <FieldIndicator fieldName="name" fieldsWithNewData={fieldsWithNewData} />
      </CardTitle>
      <CardDescription>
        Key details and information about {client.name}. Current status:
        <Badge
          variant={client.status === "active" ? "default" : "destructive"}
          className="ml-2"
        >
          {client.status || "Unknown"}
        </Badge>
      </CardDescription>
    </CardHeader>
  );
};
